import Node from '@/utils/node'
import { flattenTree } from '@/utils/util'
import merge from '@/utils/merge'
const DefaultProps = {
  expandTrigger: 'click', // or hover
  multiple: false,
  checkStrictly: false, // whether all nodes can be selected
  emitPath: true, // wether to emit an array of all levels value in which node is located
  lazy: false,
  lazyLoad: () => { },
  value: 'value',
  label: 'label',
  children: 'children',
  leaf: 'leaf',
  disabled: 'disabled',
  hoverThreshold: 500
}

export default {
  data() {
    return {
      visible: false,
      selectedList: [],
      menus: [],
      activePath: [],
      nodes: null,
      restaurants: [],
      state: '',
      maxSelected: 20,
      markers: []
    }
  },
  computed: {
    config() {
      return merge({ ...DefaultProps }, this.props || {})
    },
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler: function (val) {
        if (!val) return
        val = this.$lodash.cloneDeep(val)
        // 添加必要字段
        this.nodes = val.map(nodeData => new Node(nodeData, this.config))
        // 设置菜单
        this.menus = [this.nodes]

        // 展开搜索映射
        this.restaurants = flattenTree(this.nodes)
        this.echoListReady && this.FastSetDataAwait()
      }
    },
    visible(val) {
      val && this.setData()
    }
  },
  methods: {
    // 外部调用快捷方法
    FastSelected(node) {
      if (node.path) {
        this.clickSelect(node)
      } else {
        // 选中
        this.clearSub(this.restaurants.find(e => e.label == node.label))
        this.submitHandle()
      }
    },
    FastCancel(node) {
      const i = this.selectedList.findIndex(e => e.label == node.label)
      if (i !== -1) {
        this.deleteTag(i)
        this.submitHandle()
      }
    },
    FastSetData(data) {

      function fn(data) {
        this.clearAll()
        const transitionList = []
        data.forEach(node => {
          transitionList.push(this.restaurants.find(e => e.label == node.label))
        })
        transitionList.forEach(node => this.clickSelect(node))

        this.$nextTick(() => {
          this.submitHandle()
        })
        this.echoListReady = null
      }
      if (!this.restaurants.length) {
        this.FastSetDataAwait = fn.bind(this, data)
        return this.echoListReady = true
      }

      fn.call(this, data)
    },

    setData() {
      this.clearAll()
      const transitionList = []
      this.echoList.forEach(node => {
        transitionList.push(this.restaurants.find(e => e.label == node.label))
      })
      transitionList.forEach(node => this.clickSelect(node))
    },

    cancelHandle() {
      this.visible = false
    },
    submitHandle() {
      this.$emit('change', this.selectedList)
      this.visible = false
    },
    afterLeave() {
      this.$nextTick(() => {
        this.setData()
      })
    },
    setSelectText(item) {
      return item.label.replaceAll(this.state, `<span style="color:red;">${this.state}</span>`)
    },
    querySearch(queryString, cb) {
      const restaurants = this.restaurants
      const results = queryString ? restaurants.filter(this.createFilter(queryString)) : []
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.label.toLowerCase().indexOf(queryString.toLowerCase()) !== -1
          || queryString.toLowerCase().indexOf(restaurant.label.toLowerCase()) !== -1)
      }
    },

    searchHandle(node) {
      // 清除标记
      this.clearMarkers()
      // 不展示下一级
      node.pathNodes.slice(0, node.pathNodes.length - 1).forEach(e => {
        this.handleExpand(e)
      })

      // 菜单定位
      this.$nextTick(() => {
        node.pathNodes.forEach((n, i) => {
          const childIndex = this.menus[i].findIndex(e => e.value == n.value)
          this.clickLocation(i, childIndex)
        })
      })
    },

    setFieldsFromPath(item, path, avoidPath, fieldsObj) {
      const index = item.findIndex(e => e.value == path[0])
      const element = item[index]

      // 忽略的路径不设置
      if (avoidPath == null || !avoidPath.length || (avoidPath[0] && avoidPath[0] != path[0])) {
        for (const key in fieldsObj) {
          if (Object.hasOwnProperty.call(element, key)) {
            element[key] = fieldsObj[key]
          }
        }
      }
      // 边界
      if (path.length === 1 || !element.children) return
      this.setFieldsFromPath(element.children, path.slice(1, path.length), avoidPath?.slice(1, path.length), fieldsObj)
    },
    deleteTag(i) {
      const [node] = this.selectedList.splice(i, 1)
      // 提取忽略路径
      const avoidPath = []
      this.selectedList.forEach(e => {
        node.path.forEach((p, i) => {
          if (e.path[i] && e.path[i] == p) {
            avoidPath.push(p)
          }
        })
      })
      this.setFieldsFromPath(this.nodes, node.path, avoidPath, { selected: false })
    },
    clearAll() {
      for (let i = 0; i < this.selectedList.length; i++) {
        this.setFieldsFromPath(this.nodes, this.selectedList[i].path, null, { selected: false })
      }
      this.selectedList = []
    },
    clearSub(node) {
      // 清除标记
      this.clearMarkers()
      if (!node) {
        this.clearAll()
        return
      }
      // 清除
      this.selectedList = this.selectedList.filter(e => !e.path.includes(node.value))
      this.clickSelect(node)
    },
    clickSelect(node) {
      // 清除标记
      this.clearMarkers()
      // 展开
      this.handleExpand(node)
      // 添加列表
      this.addSelected(node)
    },
    handleExpand(node) {
      const { activePath } = this
      const { level } = node
      const path = activePath.slice(0, level - 1)
      const menus = this.menus.slice(0, level)

      if (!node.isLeaf) {
        path.push(node)
        menus.push(node.children)
      }
      this.activePath = path
      this.menus = menus
    },
    addSelected(node) {
      let future = this.selectedList
      if (this.selectedList.some(e => node.value == e.value || node.value == e.parent?.value || e.path.includes(node.value))) return
      if (node.parent) {
        future = this.selectedList.filter(e => node.parent.value != e.value)
      }

      if (future.length >= this.maxSelected) {
        return this.$message.warning(`最多可选${this.maxSelected}个`)
      }
      this.selectedList = future
      this.selectedList.push(node)

      // 选中
      this.setFieldsFromPath(this.nodes, node.path, null, { selected: true })
    },
    clickLocation(i, childIndex) {
      try {
        // 子选项多出
        const k = this.$refs.menus.children[i].children.length - this.menus[i].length
        const target = this.$refs.menus.children[i].children[childIndex + k]
        this.$refs.menus.children[i].scrollTop = target.offsetTop - 121
        // 定位标记
        this.markers.push(target)
        target.style.color = 'red'
      } catch (error) {
        console.log(error);
      }
    },
    clearMarkers() {
      this.markers.forEach(e => {
        e.style.color = null
      })
      this.markers = []
    }
  }
}